"use strict";

var _type = require("../_util/type");

var DatePickerModes = (0, _type.tuple)('time', 'date', 'month', 'year', 'decade');